var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 2.65Q12.43.92 13.67 3.63Q16.65 3.35 16.37 6.32Q19.08 7.57 17.35 10Q19.08 12.43 16.37 13.67Q16.65 16.65 13.68 16.37Q12.43 19.08 10 17.35Q7.57 19.08 6.33 16.37Q3.35 16.65 3.63 13.68Q.92 12.43 2.65 10Q.92 7.57 3.63 6.33Q3.35 3.35 6.33 3.63Q7.57.92 10 2.65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.9 5.9h2.2c1.25 0 2.05.65 2.05 1.75 0 .8-.45 1.35-1.25 1.55l1.55 3.5H8.95L7.6 9.95H7.05v2.75H5.9V5.9zm1.15 1.1v1.7h1c.5 0 .8-.25.8-.85s-.3-.85-.8-.85h-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.2 9.75c.8 0 1.3.35 1.3 1 0 .4-.2.7-.55.85.45.2.7.55.7 1.05 0 .8-.65 1.3-1.7 1.3-.9 0-1.5-.4-1.65-1.05h1.1c.08.28.35.42.65.42.35 0 .6-.15.6-.45 0-.3-.25-.42-.75-.42h-.45v-1.05h.4c.4 0 .65-.12.65-.4 0-.25-.2-.4-.55-.4-.28 0-.5.12-.65.35H10.5c.15-.7.75-1.1 1.7-1.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTag);
export default __webpack_public_path__ + "static/media/price-tag.93707ba4b7a24f278eb89af715a56215.svg";
export { ForwardRef as ReactComponent };